import type { ShpeshftDocument } from './document';
import { exportSvg } from './svg';

const usableDimension = (value: number) => Number.isFinite(value) && value > 0;

export function hasProjectPreviewContent(document: ShpeshftDocument): boolean {
  if (document.workspace.backgroundImage?.dataUrl) return true;
  return document.order.some((id) => Boolean(document.objects[id]?.visible));
}

export function projectPreviewAspect(document: ShpeshftDocument): number {
  if (document.projectType === 'asset') return 1;
  if (document.projectType !== 'design' || !hasProjectPreviewContent(document)) return 1;
  const { width, height } = document.workspace;
  return usableDimension(width) && usableDimension(height) ? width / height : 1;
}

export function projectPreviewSvg(document: ShpeshftDocument): string {
  if (!hasProjectPreviewContent(document)) {
    return '<svg xmlns="http://www.w3.org/2000/svg" width="1" height="1" viewBox="0 0 1 1"><rect width="1" height="1" fill="#fff"/></svg>';
  }
  const { width, height } = document.workspace;
  if (document.projectType !== 'asset' && (!usableDimension(width) || !usableDimension(height))) {
    return '<svg xmlns="http://www.w3.org/2000/svg" width="1" height="1" viewBox="0 0 1 1"><rect width="1" height="1" fill="#fff"/></svg>';
  }
  return exportSvg(document);
}

export const projectPreviewDataUrl = (document: ShpeshftDocument) =>
  document.projectType==='copy'&&document.workspace.backgroundImage?.dataUrl
    ? document.workspace.backgroundImage.dataUrl
    : `data:image/svg+xml,${encodeURIComponent(projectPreviewSvg(document))}`;
